import VariantList from './variant-list';

export default VariantList;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/VariantList/index.js